import {useDefaultQuery} from "../../../../client/useDefaultQuery";
import {SubmissionApiClient, SubmissionDto} from "../../../../client/submission/SubmissionApiClient";

export function usePaymentRequiredQuery(
    submissionId: number | undefined,
    submissionApiClient: SubmissionApiClient,
    authorizationSucceeded: boolean = true
) {
    return useDefaultQuery({
        queryKey: ["submission", submissionId, "payment-required"],
        queryFn: () => new Promise<SubmissionDto>((resolve, reject) => {
            submissionApiClient.findById(submissionId!)
                .then((result) => {
                    if (result?.paymentRequired === true || result?.paymentRequired === false) {
                        return resolve(result);
                    }

                    return reject(new Error("Payment required status is not yet determined"));
                })
        }),
        enabled: !!submissionId && authorizationSucceeded,
        retry: (failureCount) => failureCount < 10,
        retryDelay: () => 1000,
    });
}
